<template>
  <div id="page-product-details">
    <market-form
        v-model="model"
        ref="form"
        :loading="loading"
        :card-title="cardTitle"
    />
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              class="my-4"
              @click="$router.push({ name: 'facilities.markets.list' })"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              class="my-4"
              color="light"
              @click="save"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationMixin from "@/components/mixins/NotificationMixin";
import MarketForm from '@/views/pages/facilities/markets/MarketForm';
import ViewModelMixin from '@/components/mixins/ViewModelMixin';
import SaveModelMixin from '@/components/mixins/SaveModelMixin';

export default {
  name: "MarketEdit",
  components: {
    MarketForm,
  },
  mixins: [ViewModelMixin, SaveModelMixin, NotificationMixin],
  data() {
    return {
      loading: false,
      modelEntity: this.$api.facilities.markets,
      entity: 'Market:',
    };
  },
  computed: {
    cardTitle() {
      if (this.model.MarketName) {
        return 'Market: ' + this.model.MarketName;
      }

      return 'Market:';
    },
    id() {
      return this.$route.params.marketId;
    },
  },
  methods: {
    getParams() {
      const params = this.getModelCopy(true);
      this.setDates(['InceptionDate', 'ExpiryDate'])
      delete params.Facility_FK;

      return params;
    },
    postSave() {
      this.$router.back();
    },
  },
};
</script>
